export const isCoordinatorOnly = (roles: string[]) => roles.includes('meeting_coordinator') && !roles.includes('admin')
